import type { ActionHandler } from '../types';
import { intentValue, invokeSemanticPort, readString } from './helpers';

export const captureLeadHandler: ActionHandler = {
  type: 'capture_lead',
  execute(ctx) {
    const config = ctx.config;
    const port = ctx.semanticPorts?.captureLead;
    return invokeSemanticPort(
      ctx,
      'capture_lead',
      port
        ? (context) =>
            port(
              {
                formId: readString(config, 'formId', 'form_id'),
                leadSource: readString(config, 'leadSource', 'lead_source'),
                value: intentValue(ctx),
              },
              context
            )
        : undefined
    );
  },
};
